import { FC, useState } from 'react';
import { Button, ButtonStyles, Icons } from '@silverfort/sf-components';
import PoliciesDashboardsDisclaimers from '../../../../components/PoliciesDashboardsDisclaimers/PoliciesDashboardsDisclaimers';
import { Popover } from '@material-ui/core';

const DISCLAIMERS = [
    'This page shows data for human users only.',
    'Data reflects the selected timeframe. Logs outside your configured retention window may be unavailable.',
    'Pie chart metrics show the distribution of MFA activity types for human users, based on logs from the selected timeframe.'
];

const Disclaimers: FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setIsOpen(true);
    };

    const handlePopoverClose = () => {
        setIsOpen(false);
        setAnchorEl(null);
    };

    return (
        <>
            <Button iconLeft={Icons.CircleInfo} buttonStyle={ButtonStyles.Primary} onClick={handleButtonClick} />
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                classes={{
                    root: 'z-[10000]',
                    paper: 'my-0.5 mx-[-8px] shadow-[0px_4px_8px_0px_#0000001A] rounded-[8px] border border-sf-gray-100'
                }}>
                <PoliciesDashboardsDisclaimers
                    title="Information"
                    disclaimers={DISCLAIMERS}
                    onClose={handlePopoverClose}
                />
            </Popover>
        </>
    );
};

export default Disclaimers;
